import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Alert,
  CircularProgress,
  Breadcrumbs,
  Link,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { categoryMasterAPI, masterDataAPI } from "../services/api";
import Swal from "sweetalert2";
import $ from "jquery";
import "select2";
import "select2/dist/css/select2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./RaiseComplaint.css";
import "./AddEditCategoryMaster.css";

const normalizeMarket = (item) => ({
  marketCode: item.marketCode || item.MarketCode || item.marketcode || "",
  marketName: item.marketName || item.MarketName || item.marketname || "",
});

const normalizeCategory = (item) => ({
  catgCode: item.catgCode || item.CatgCode || item.CATGCODE || "",
  catgId: item.catgId || item.CatgId || item.CATGID || "",
  catgName: item.catgName || item.CatgName || item.CATGNAME || "",
  marketCode: item.marketCode || item.MarketCode || item.MARKETCODE || "",
  isActive: item.isActive ?? item.IsActive ?? true,
});

const AddEditCategoryMaster = () => {
  const navigate = useNavigate();
  const { catgCode } = useParams();
  const isEditMode = !!catgCode;

  const [category, setCategory] = useState({
    catgCode: "",
    catgId: "",
    catgName: "",
    marketCode: "",
    isActive: true,
  });

  const [dropdowns, setDropdowns] = useState({
    markets: [],
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const marketSelectRef = useRef(null);

  const currentUser = (() => {
    try {
      const u = localStorage.getItem("user");
      return u ? JSON.parse(u) : null;
    } catch (e) {
      return null;
    }
  })();

  useEffect(() => {
    loadDropdowns();
    if (isEditMode) {
      loadCategory();
    } else {
      loadNextCategoryCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catgCode]);

  // Initialize Select2 for Market dropdown
  useEffect(() => {
    if (dropdowns.markets.length === 0) {
      return;
    }

    if (marketSelectRef.current) {
      const $marketSelect = $(marketSelectRef.current);
      if ($marketSelect.data("select2")) {
        $marketSelect.select2("destroy");
      }
      $marketSelect.select2({
        width: "100%",
        placeholder: "Select Market",
        allowClear: false,
      });
      $marketSelect.on("select2:select", function (e) {
        // Get the value attribute from the selected option (MARKETCODE like "M001")
        const selectedMarketCode = $(this).val() || "";
        console.log("🔵 [Select2:select] Event fired");
        console.log("🔵 [Select2:select] e.params:", e.params);
        console.log("🔵 [Select2:select] e.params.data:", e.params?.data);
        console.log("🔵 [Select2:select] e.params.data.id:", e.params?.data?.id);
        console.log("🔵 [Select2:select] $(this).val():", $(this).val());
        console.log("🔵 [Select2:select] e.target.value:", e.target?.value);
        console.log("🔵 [Select2:select] Selected MarketCode:", selectedMarketCode);
        if (selectedMarketCode) {
          handleChange("marketCode", selectedMarketCode);
        }
      });
      // Also listen to native change event as fallback
      $marketSelect.on("change", function (e) {
        // Get the value attribute from the select element
        const selectedMarketCode = $(this).val() || e.target.value || "";
        console.log("🟢 [Change] Event fired");
        console.log("🟢 [Change] $(this).val():", $(this).val());
        console.log("🟢 [Change] e.target.value:", e.target?.value);
        console.log("🟢 [Change] Selected MarketCode:", selectedMarketCode);
        console.log("🟢 [Change] Current category.marketCode:", category.marketCode);
        if (selectedMarketCode && selectedMarketCode !== category.marketCode) {
          handleChange("marketCode", selectedMarketCode);
        }
      });
      if (category.marketCode) {
        $marketSelect.val(category.marketCode).trigger("change");
      }
    }

    return () => {
      if (marketSelectRef.current) {
        const $select = $(marketSelectRef.current);
        if ($select.data("select2")) {
          $select.off("select2:select change");
          $select.select2("destroy");
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdowns.markets]);

  // Log category state changes
  useEffect(() => {
    console.log("🟠 [Category State] Full category object:", category);
    console.log("🟠 [Category State] category.marketCode:", category.marketCode);
    console.log("🟠 [Category State] category.marketCode type:", typeof category.marketCode);
  }, [category]);

  // Update Select2 value when category state changes
  useEffect(() => {
    console.log("🟠 [Category.marketCode Effect] category.marketCode:", category.marketCode);
    if (marketSelectRef.current && dropdowns.markets.length > 0) {
      const $marketSelect = $(marketSelectRef.current);
      if ($marketSelect.data("select2")) {
        const currentVal = $marketSelect.val();
        console.log("🟠 [Category.marketCode Effect] Current Select2 value:", currentVal);
        console.log("🟠 [Category.marketCode Effect] category.marketCode:", category.marketCode);
        if (currentVal !== (category.marketCode || "")) {
          console.log("🟠 [Category.marketCode Effect] Updating Select2 value to:", category.marketCode);
          $marketSelect.val(category.marketCode || "").trigger("change");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category.marketCode]);

  const loadDropdowns = async () => {
    try {
      setLoading(true);
      const marketRes = await masterDataAPI.getMarkets();
      console.log("🟣 [loadDropdowns] Raw market response:", marketRes);
      console.log("🟣 [loadDropdowns] marketRes.data:", marketRes?.data);
      console.log("🟣 [loadDropdowns] marketRes.data.markets:", marketRes?.data?.markets);
      console.log("🟣 [loadDropdowns] marketRes.data.Markets:", marketRes?.data?.Markets);
      console.log("🟣 [loadDropdowns] Full response keys:", Object.keys(marketRes?.data || {}));
      console.log("🟣 [loadDropdowns] Full response:", JSON.stringify(marketRes?.data, null, 2));

      // Extract Markets from response
      // 
      // BACKEND FIX REQUIRED:
      // The backend MasterDataService.GetMarketsAsync() is currently hardcoded.
      // It needs to read from MARKETMASTER table to return actual MARKETCODE values (M001, M002, 0000)
      // instead of hardcoded "DOM" and "EXP".
      // 
      // Expected database values:
      // - MARKETCODE: 0000, M001, M002
      // - MARKETNAME: Default Market, Domestic Market, Export Market
      //
      // The response structure should be: { data: { Markets: [...], TotalRecords: ... } }
      let marketsArray = [];
      if (marketRes?.data?.Markets && Array.isArray(marketRes.data.Markets)) {
        marketsArray = marketRes.data.Markets;
      } else if (marketRes?.data?.markets && Array.isArray(marketRes.data.markets)) {
        marketsArray = marketRes.data.markets;
      } else if (Array.isArray(marketRes?.data)) {
        marketsArray = marketRes.data;
      } else if (marketRes?.data?.data?.Markets && Array.isArray(marketRes.data.data.Markets)) {
        marketsArray = marketRes.data.data.Markets;
      } else if (marketRes?.data?.data?.markets && Array.isArray(marketRes.data.data.markets)) {
        marketsArray = marketRes.data.data.markets;
      }

      console.log("🟣 [loadDropdowns] Extracted markets array:", marketsArray);
      console.log("🟣 [loadDropdowns] First raw market object:", marketsArray[0]);
      if (marketsArray[0]) {
        console.log("🟣 [loadDropdowns] First market keys:", Object.keys(marketsArray[0]));
        console.log("🟣 [loadDropdowns] First market all properties:", JSON.stringify(marketsArray[0], null, 2));
      }

      const normalizedMarkets = marketsArray.map((m) => normalizeMarket(m));
      console.log("🟣 [loadDropdowns] Normalized markets:", normalizedMarkets);
      console.log("🟣 [loadDropdowns] First normalized market:", normalizedMarkets[0]);

      setDropdowns({
        markets: normalizedMarkets,
      });
    } catch (e) {
      console.error("Error loading dropdowns:", e);
      setError("Failed to load dropdown data. Please refresh the page.");
    } finally {
      setLoading(false);
    }
  };

  const loadNextCategoryCode = async () => {
    try {
      const response = await categoryMasterAPI.getNextCode();
      if (response && response.success && response.data) {
        setCategory((prev) => ({ ...prev, catgCode: response.data }));
      }
    } catch (e) {
      console.error("Error loading next category code:", e);
      setCategory((prev) => ({ ...prev, catgCode: "CATG00001" }));
    }
  };

  const loadCategory = async () => {
    try {
      setLoading(true);
      const response = await categoryMasterAPI.getByCode(catgCode);
      if (response && response.success && response.data) {
        setCategory(normalizeCategory(response.data));
      } else {
        navigate("/product-categories");
      }
    } catch (e) {
      console.error("Error loading category:", e);
      if (e.response?.status !== 404) {
        Swal.fire("Error", "Failed to load product category details", "error");
      }
      navigate("/categories");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    console.log("🟡 [handleChange] Field:", field);
    console.log("🟡 [handleChange] Value:", value);
    console.log("🟡 [handleChange] Value type:", typeof value);
    console.log("🟡 [handleChange] Previous category:", category);
    setCategory((prev) => {
      const updated = { ...prev, [field]: value };
      console.log("🟡 [handleChange] Updated category:", updated);
      return updated;
    });
  };

  const validateForm = () => {
    if (!category.catgCode?.trim()) {
      Swal.fire("Error", "Product Category Code is required", "error");
      return false;
    }
    if (!category.catgId?.trim()) {
      Swal.fire("Error", "Product Category ID is required", "error");
      return false;
    }
    if (!category.catgName?.trim()) {
      Swal.fire("Error", "Product Category Name is required", "error");
      return false;
    }
    if (!category.marketCode) {
      Swal.fire("Error", "Market is required", "error");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    console.log("🔴 [handleSave] Category object before validation:", category);
    console.log("🔴 [handleSave] category.marketCode:", category.marketCode);
    console.log("🔴 [handleSave] category.marketCode type:", typeof category.marketCode);
    
    if (!validateForm()) return;

    console.log("🔴 [handleSave] Category object after validation:", category);
    console.log("🔴 [handleSave] Sending to API - category.marketCode:", category.marketCode);
    
    setSaving(true);
    try {
      const createdBy = currentUser?.userIdCode || "SYSADMIN001";
      console.log("🔴 [handleSave] CreatedBy:", createdBy);
      console.log("🔴 [handleSave] Full category payload:", JSON.stringify(category, null, 2));
      
      let response;

      if (isEditMode) {
        console.log("🔴 [handleSave] Update mode - catgCode:", catgCode);
        response = await categoryMasterAPI.update(
          catgCode,
          category,
          createdBy
        );
      } else {
        console.log("🔴 [handleSave] Create mode");
        response = await categoryMasterAPI.create(category, createdBy);
      }
      
      console.log("🔴 [handleSave] API Response:", response);

      if (response && response.success) {
        Swal.fire({
          title: "Success",
          text: response.message || "Product category saved successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/product-categories");
        });
      } else {
        Swal.fire(
          "Error",
          response.message || "Failed to save product category",
          "error"
        );
      }
    } catch (e) {
      console.error("Error saving category:", e);
      Swal.fire(
        "Error",
        e.response?.data?.message ||
          "Failed to save product category. Please try again.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box className="add-edit-product-loading">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box className="add-edit-product-header">
        <Breadcrumbs
          aria-label="breadcrumb"
          className="add-edit-product-breadcrumb"
        >
          <Link
            underline="hover"
            color="inherit"
            href="/product-categories"
            onClick={(e) => {
              e.preventDefault();
              navigate("/product-categories");
            }}
            className="breadcrumb-link brdcrmbLstitms"
          >
            Product Category
          </Link>
          <Typography
            color="text.primary"
            className="breadcrumb-current brdcrmbLstitms brdcrmbCurPg"
          >
            {isEditMode ? "Edit Product Category" : "Add Product Category"}
          </Typography>
        </Breadcrumbs>
        <Box className="add-edit-product-header-right">
          <Button
            className="add-edit-product-back-button"
            onClick={() => navigate("/categories")}
            startIcon={<ArrowBackIcon />}
          >
            Back
          </Button>
        </Box>
      </Box>

      {error && (
        <Alert
          severity="error"
          className="add-edit-product-error-alert"
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      )}

      <div className="container-fluid add-edit-product-page">
        {/* Basic Information Section */}
        <div className="card-panel mb-3">
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="textfield-wrapper">
                <label className="select2-label pnlLblsze">
                  Product Category ID <span className="required-asterisk">*</span>
                </label>
                <TextField
                  value={category.catgId}
                  onChange={(e) => handleChange("catgId", e.target.value)}
                  required
                  fullWidth
                  size="small"
                  placeholder="Enter product category ID"
                  className="add-edit-product-textfield"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="select2-wrapper">
                <label className="select2-label pnlLblsze">
                  Market <span className="required-asterisk">*</span>
                </label>
                <select
                  ref={marketSelectRef}
                  className="form-control select2-category"
                  required
                >
                  <option value="">Select Market</option>
                  {dropdowns.markets.map((m) => {
                    // Log each option being rendered
                    if (dropdowns.markets.indexOf(m) === 0) {
                      console.log("⚪ [Render Options] Sample option - marketCode:", m.marketCode, "marketName:", m.marketName);
                    }
                    return (
                      <option key={m.marketCode} value={m.marketCode}>
                        {m.marketName} ({m.marketCode})
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="textfield-wrapper">
                <label className="select2-label pnlLblsze">
                  Product Category Name <span className="required-asterisk">*</span>
                </label>
                <TextField
                  value={category.catgName}
                  onChange={(e) => handleChange("catgName", e.target.value)}
                  required
                  fullWidth
                  size="small"
                  placeholder="Enter product category name"
                  className="add-edit-product-textfield"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 hidden-field">
              <div className="textfield-wrapper">
                <label className="select2-label pnlLblsze">
                  Category Code <span className="required-asterisk">*</span>
                </label>
                <TextField
                  value={category.catgCode}
                  required
                  fullWidth
                  disabled={true}
                  size="small"
                  className="add-edit-product-textfield"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                variant="contained"
                onClick={() => navigate("/categories")}
                className="btn-cancel-product funbtns"
                startIcon={<CancelIcon />}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving}
                startIcon={
                  saving ? <CircularProgress size={20} /> : <SaveIcon />
                }
                className="btn-save-product funbtns"
              >
                {saving ? "Saving..." : "Save"}
              </Button>
            </Stack>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default AddEditCategoryMaster;
